// ------------------------------------
// Imports
// ------------------------------------

import { API_REQUEST_STATUS_LOADING, API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'
import protocols  from '../../common-protocols';
// ------------------------------------
// Constants
// ------------------------------------

/* obtener el token */
export const GET_TOKEN = 'GET_TOKEN'
export const GET_TOKEN_FAILED = 'GET_TOKEN_FAILED'
export const GET_TOKEN_SUCCEEDED = 'GET_TOKEN_SUCCEEDED'

/* Nuevo token */
export const PUT_TOKEN = 'PUT_TOKEN'
export const PUT_TOKEN_FAILED = 'PUT_TOKEN_FAILED'
export const PUT_TOKEN_SUCCEEDED = 'PUT_TOKEN_SUCCEEDED'

/* finalizar session */
export const FINISH_SESSION = 'FINISH_SESSION'
export const FINISH_SESSION_FAILED = 'FINISH_SESSION_FAILED'
export const FINISH_SESSION_SUCCEEDED = 'FINISH_SESSION_SUCCEEDED'

export const GET_TICKET = 'GET_TICKET'
export const GET_TICKET_FAILED = 'GET_TICKET_FAILED'
export const GET_TICKET_SUCCEEDED = 'GET_TICKET_SUCCEEDED'

export const FINISH_TICKET = 'FINISH_TICKET'
export const FINISH_TICKET_FAILED = 'FINISH_TICKET_FAILED'
export const FINISH_TICKET_SUCCEEDED = 'FINISH_TICKET_SUCCEEDED'

export const SEND_EMAIL = 'SEND_EMAIL'
export const SEND_EMAIL_FAILED = 'SEND_EMAIL_FAILED'
export const SEND_EMAIL_SUCCEEDED = 'SEND_EMAIL_SUCCEEDED'

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const UPDATE_USER_DATA_FAILED = 'UPDATE_USER_DATA_FAILED'
export const UPDATE_USER_DATA_SUCCEEDED = 'UPDATE_USER_DATA_SUCCEEDED'

/* guardar la ultima ruta que se accedió */
export const SET_LAST_ROUTE = 'SET_LAST_ROUTE'

/* bandera para determinar si el usuario realizo el login */
export const SET_ACCESS_GRANTED = 'SET_ACCESS_GRANTED'

/* guardar la hora de inicio de sesion */
export const SET_START_HOUR = 'SET_START_HOUR'

/* guardar la hora en que el token caducara */
export const SET_END_HOUR = 'SET_END_HOUR'

/* esrtablecer tiempos para determinar cuando el token caducara */
export const SET_TOKEN_EXPIRED = 'SET_TOKEN_EXPIRED'

/* actualizar estados desde la Storage */
export const SET_UPDATE_SESSION = 'SET_UPDATE_SESSION'

export const SET_ID_SESSION = 'SET_ID_SESSION'

export const SET_ID_MARKET = 'SET_ID_MARKET'

export const SET_COMBINACION = 'SET_COMBINACION'

export const SET_STARTING_MONEY = 'SET_STARTING_MONEY'

export const SET_TICKET = 'SET_TICKET'

export const SET_HAS_TICKET = 'SET_HAS_TICKET'

export const SET_USER_SESSION_DATA = 'SET_USER_SESSION_DATA';

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LANGUAGE_FAILED = 'SET_LANGUAGE_FAILED';
export const SET_LANGUAGE_SUCCESS = 'SET_LANGUAGE_SUCCESS';

export const GET_LANGUAGE = 'GET_LANGUAGE';
export const GET_LANGUAGE_FAILED = 'GET_LANGUAGE_FAILED';
export const GET_LANGUAGE_SUCCESS = 'GET_LANGUAGE_SUCCESS';

export const SET_LAST_PATH = 'SET_LAST_PATH';
export const SET_LAST_PATH_FAILED = 'SET_LAST_PATH_FAILED';
export const SET_LAST_PATH_SUCCEEDED = 'SET_LAST_PATH_SUCCEEDED';

export const SET_CAMPAIGN = 'SET_CAMPAIGN';

export const SET_ACEPTABILIDAD_RESUMEN = 'SET_ACEPTABILIDAD_RESUMEN';

export const END_PROCESS = 'END_PROCESS';

// ------------------------------------
// Actions
// ------------------------------------

export function getToken(callback) {
  return {
    type : GET_TOKEN,
    callback
  }
}

export function getTokenFailed(error) {
  return {
    type : GET_TOKEN_FAILED,
    error
  }
}

export function getTokenSucceeded(token) {
  return {
    type : GET_TOKEN_SUCCEEDED,
    payload : token
  }
}

export function putToken(token, callback) {
  return {
    type: PUT_TOKEN,
    token,
    callback
  }
}

export function putTokenFailed(error) {
  return {
    type: PUT_TOKEN_FAILED,
    error
  }
}

export function putTokenSucceeded() {
  return {
    type: PUT_TOKEN_SUCCEEDED
  }
}

export function finishSession(token, callback = null) {
  return {
    type: FINISH_SESSION,
    token,
    callback
  }
}

export function finishSessionFailed(error) {
  return {
    type: FINISH_SESSION_FAILED,
    error
  }
}

export function finishSessionSucceeded() {
  return {
    type: FINISH_SESSION_SUCCEEDED
  }
}

export function getTicket(token, term, callback = null) {
  return {
    type: GET_TICKET,
    token,
    term,
    callback
  }
}

export function getTicketFailed(error) {
  return {
    type: GET_TICKET_FAILED,
    error
  }
}

export function getTicketSucceeded(data) {
  return {
    type: GET_TICKET_SUCCEEDED,
    payload: data
  }
}

export function finishTicket(token, term, callback = null) {
  return {
    type: FINISH_TICKET,
    token,
    term,
    callback
  }
}

export function finishTicketFailed(error) {
  return {
    type: FINISH_TICKET_FAILED,
    error
  }
}

export function finishTicketSucceeded() {
  return {
    type: FINISH_TICKET_SUCCEEDED
  }
}

export function sendEmail(token, term, callback = null) {
  return {
    type: SEND_EMAIL,
    token,
    term,
    callback
  }
}

export function sendEmailFailed(error) {
  return {
    type: SEND_EMAIL_FAILED,
    error
  }
}

export function sendEmailSucceeded() {
  return {
    type: SEND_EMAIL_SUCCEEDED
  }
}

export function updateUserData(token, term, callback = null) {
  return {
    type: UPDATE_USER_DATA,
    token,
    term,
    callback
  }
}

export function updateUserDataFailed(error) {
  return {
    type: UPDATE_USER_DATA_FAILED,
    error
  }
}

export function updateUserDataSucceeded() {
  return {
    type: UPDATE_USER_DATA_SUCCEEDED,
  }
}

export function setLastRoute(data) {
  return {
    type : SET_LAST_ROUTE ,
    payload : data
  }
}

export function setAccessGranted(data) {
  return {
    type : SET_ACCESS_GRANTED,
    payload : data
  }
}

export function setStartHour(data) {
  return {
    type : SET_START_HOUR,
    payload : data
  }
}

export function setEndHour(data) {
  return {
    type : SET_END_HOUR,
    payload: data
  }
}

export function setTokenExpired(data) {
  return {
    type: SET_TOKEN_EXPIRED,
    payload: data
  }
}

export function setUpdateSession(data) {
  return {
    type : SET_UPDATE_SESSION,
    payload : data
  }
}

export function setIdSession(data) {
  return {
    type : SET_ID_SESSION,
    payload : data
  }
}

export function setIdMarket(data) {
  return {
    type : SET_ID_MARKET,
    payload : data
  }
}

export function setCombinacion(data) {
  return {
    type: SET_COMBINACION,
    payload: data
  }
}

export function setStartingMoney(data) {
  return {
    type : SET_STARTING_MONEY,
    payload : data
  }
}

export function setTicket(data) {
  return {
    type: SET_TICKET,
    payload: data
  }
}

export function setHasTicket(data) {
  return {
    type: SET_HAS_TICKET,
    payload: data
  }
}

export function setUserSessionData({idSession, idMarket, combinacion}){
  return {
    type: SET_USER_SESSION_DATA,
    idSession,
    idMarket,
    combinacion
  }
}

export function setCampaign(idPais, campaign){
  return {
    type: SET_CAMPAIGN,
      idPais,
      campaign,
      abreviatura: protocols.PAIS[idPais]
  }
}

export function setLanguage({language, token}){
  return {
    type: SET_LANGUAGE,
    language,
    token
  }
}

export function setLanguageFailed(error){
  return {
    type: SET_LANGUAGE_FAILED,
    error
  }
}

export function setLanguageSuccess(language){
  return {
    type: SET_LANGUAGE_SUCCESS,
    language
  }
}

export function getLanguage(){
  return {
    type: GET_LANGUAGE
  }
}

export function getLanguageFailed(error){
  return {
    type: GET_LANGUAGE_FAILED,
    error
  }
}

export function getLanguageSuccess(language){
  return {
    type: GET_LANGUAGE_SUCCESS,
    language
  }
}

export function setLastPath({token, path}){
  return {
    type: SET_LAST_PATH,
    token,
    path
  }
}

export function setLastPathFailed(){
  return {
    type: SET_LAST_PATH_FAILED
  }
}

export function setLastPathSuccess(path){
  return {
    type: SET_LAST_PATH_SUCCEEDED,
    path
  }
}

export function setAceptabilidad(aceptabilidad){
  return {
    type: SET_ACEPTABILIDAD_RESUMEN,
    aceptabilidad
  }
}

export function endProcess(token, callback = null){
  return {
    type: END_PROCESS,
    token,
    callback
  }
}

export const actions = {
  getToken,
  getTokenFailed,
  getTokenSucceeded,
  putToken,
  putTokenFailed,
  putTokenSucceeded,
  finishSession,
  finishSessionFailed,
  finishSessionSucceeded,
  getTicket,
  getTicketFailed,
  getTicketSucceeded,
  finishTicket,
  finishTicketFailed,
  finishTicketSucceeded,
  setLastRoute,
  setStartHour,
  setEndHour,
  setTokenExpired,
  setAccessGranted,
  setIdSession,
  setIdMarket,
  setCombinacion,
  setStartingMoney,
  setTicket,
  setHasTicket,
  sendEmail,
  sendEmailFailed,
  sendEmailSucceeded,
  updateUserData,
  updateUserDataFailed,
  updateUserDataSucceeded,
  setUserSessionData,
  setLanguage,
  getLanguage,
  setLanguageSuccess,
  setLastPath,
  setLastPathFailed,
  setLastPathSuccess,
  setCampaign,
  setAceptabilidad,
  endProcess
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

  [GET_TOKEN]: (state, action) => ({
    ...state,
    getTokenStatus : API_REQUEST_STATUS_LOADING,
    getTokenError : -1
  }),

  [GET_TOKEN_FAILED]: (state, action) => ({
    ...state,
    getTokenStatus : API_REQUEST_STATUS_FAILED,
    getTokenError : action.error
  }),

  [GET_TOKEN_SUCCEEDED]: (state, action) => ({
    ...state,
    token : action.payload,
    getTokenStatus : API_REQUEST_STATUS_SUCCEEDED,
    getTokenError : action.error
  }),

  [PUT_TOKEN]: (state, action) => ({
    ...state,
    putTokenStatus: API_REQUEST_STATUS_LOADING,
    putTokenRrror: -1
  }),

  [PUT_TOKEN_FAILED]: (state, action) => ({
    ...state,
    putTokenStatus: API_REQUEST_STATUS_FAILED,
    putTokenError: action.error
  }),

  [PUT_TOKEN_SUCCEEDED]: (state, action) => ({
    ...state,
    putTokenStatus: API_REQUEST_STATUS_SUCCEEDED,
    putTokenError: -1
  }),

  [FINISH_SESSION]: (state, action) => ({
    ...state,
    finishSessionStatus: API_REQUEST_STATUS_LOADING,
    finishSessionError: -1
  }),

  [FINISH_SESSION_FAILED]: (state, action) => ({
    ...state,
    finishSessionStatus: API_REQUEST_STATUS_FAILED,
    finishSessionError: action.error
  }),

  [FINISH_SESSION_SUCCEEDED]: (state, action) => ({
    ...state,
    finishSessionStatus: API_REQUEST_STATUS_SUCCEEDED,
    finishSessionError: -1
  }),

  [GET_TICKET]: (state, action) => ({
    ...state,
    getTicketStatus : API_REQUEST_STATUS_LOADING,
    getTicketError : -1
  }),

  [GET_TICKET_FAILED]: (state, action) => ({
    ...state,
    getTicketStatus : API_REQUEST_STATUS_FAILED,
    getTicketError : action.error
  }),

  [GET_TICKET_SUCCEEDED]: (state, action) => ({
    ...state,
    getTicketStatus : API_REQUEST_STATUS_SUCCEEDED,
    getTicketError: -1,
    ticket: action.payload,
    hasTicket: true
  }),

  [FINISH_TICKET]: (state, action) => ({
    ...state,
    finishTicketStatus : API_REQUEST_STATUS_LOADING,
    finishTicketError : -1
  }),

  [FINISH_TICKET_FAILED]: (state, action) => ({
    ...state,
    finishTicketStatus : API_REQUEST_STATUS_FAILED,
    finishTicketError : action.error
  }),

  [FINISH_TICKET_SUCCEEDED]: (state, action) => ({
    ...state,
    finishTicketStatus : API_REQUEST_STATUS_SUCCEEDED,
    finishTicketError : -1
  }),

  [SEND_EMAIL]: (state, action) => ({
    ...state,
    sendEmailStatus : API_REQUEST_STATUS_LOADING,
    sendEmailError : -1
  }),

  [SEND_EMAIL_FAILED]: (state, action) => ({
    ...state,
    sendEmailStatus : API_REQUEST_STATUS_FAILED,
    sendEmailError : action.error
  }),

  [SEND_EMAIL_SUCCEEDED]: (state, action) => ({
    ...state,
    sendEmailStatus : API_REQUEST_STATUS_SUCCEEDED,
    sendEmailError : -1
  }),

  [UPDATE_USER_DATA]: (state, action) => ({
    ...state,
    updateUserDataStatus : API_REQUEST_STATUS_LOADING,
    updateUSerDataError : -1
  }),

  [UPDATE_USER_DATA_FAILED]: (state, action) => ({
    ...state,
    updateUserDataStatus : API_REQUEST_STATUS_FAILED,
    updateUSerDataError : action.error
  }),

  [UPDATE_USER_DATA_SUCCEEDED]: (state, action) => ({
    ...state,
    updateUserDataStatus : API_REQUEST_STATUS_SUCCEEDED,
    updateUSerDataError : -1
  }),

  [SET_LAST_ROUTE]: (state, action) => ({
    ...state,
    lastRoute: action.payload
  }),

  [SET_ACCESS_GRANTED]: (state, action) => ({
    ...state,
    accessGranted: action.payload
  }),

  [SET_START_HOUR]: (state, action) => ({
    ...state,
    startHour: action.payload
  }),

  [SET_END_HOUR]: (state, action) => ({
    ...state,
    endHour: action.payload
  }),

  [SET_TOKEN_EXPIRED]: (state, action) => ({
    ...state,
    startHour: action.payload.startHour,
    endHour: action.payload.endHour
  }),

  [SET_ID_SESSION]: (state, action) => ({
    ...state,
    idSession: action.payload
  }),

  [SET_ID_MARKET] : (state, action) => ({
    ...state,
    idMarket: action.payload
  }),

  [SET_COMBINACION] : (state, action) => ({
    ...state,
    combinacion: action.payload
  }),

  [SET_STARTING_MONEY] : (state, action) => ({
    ...state,
    startingMoney: action.payload
  }),

  [SET_TICKET]: (state, action) => ({
    ...state,
    ticket: action.payload
  }),

  [SET_HAS_TICKET]: (state, action) => ({
    ...state,
    hasTicket: action.payload
  }),

  [SET_UPDATE_SESSION] : (state, action) => ({
    ...state,
    token: action.payload.token,
    lastRoute: action.payload.lastRoute,
    accessGranted: action.payload.accessGranted,
    startHour: action.payload.startHour,
    endHour: action.payload.endHour,
    idSession: action.payload.idSession,
    idMarket: action.payload.idMarket,
    combinacion: action.payload.combinacion,
    startingMoney: action.payload.startingMoney,
    ticket: action.payload.ticket,
    hasTicket: action.payload.hasTicket,
  }),

  [SET_USER_SESSION_DATA] : ( state, {idSession, idMarket, combinacion}) => ({
    ...state,
    idSession,
    idMarket,
    combinacion
  }),

    [SET_CAMPAIGN] : ( state, {idPais, campaign, abreviatura}) => ({
    ...state,
    idPais,
    campaign,
    abreviatura
  }),

  [SET_LANGUAGE] : (state, {language}) => ({
    ...state,
    language_status: API_REQUEST_STATUS_LOADING
  }),

  [SET_LANGUAGE_FAILED] : (state, {language}) => ({
    ...state,
    language_status: API_REQUEST_STATUS_FAILED
  }),

  [SET_LANGUAGE_SUCCESS] : (state, {language}) => ({
    ...state,
    language,
    language_status: API_REQUEST_STATUS_SUCCEEDED
  }),

  [GET_LANGUAGE] : (state, payload) => ({
    ...state,
    language_status: API_REQUEST_STATUS_LOADING
  }),

  [GET_LANGUAGE_FAILED] : (state, {error}) => ({
    ...state,
    language_status: API_REQUEST_STATUS_FAILED
  }),

  [GET_LANGUAGE_SUCCESS] : (state, {language}) => ({
    ...state,
    language,
    language_status: API_REQUEST_STATUS_SUCCEEDED
  }),
  [SET_LAST_PATH_SUCCEEDED]: (state, {path}) => ({
    ...state,
    lastPath: path
  }),
  [SET_ACEPTABILIDAD_RESUMEN]: (state, {aceptabilidad}) => ({
    ...state,
    aceptabilidad
  })
}

// ------------------------------------
// Reducer
// ------------------------------------
const language = localStorage.getItem('language');
const initialState = {
  accessGranted : false,
  token : '',
  getTokenStatus : -1,
  getTokenError : -1,
  putTokenStatus: -1,
  putTokenError: -1,
  finishSessionStatus: -1,
  finishSessionError: -1,

  ticket : {
    pkBoleto: -1,
    terminado: -1,
    fechaTerminacion: -1,
    habilitado: -1,
    fechaInicio: -1
  },
  hasTicket: false,
  getTicketStatus: -1,
  getTicketError : -1,

  finishTicketStatus: -1,
  finishTicketError: -1,

  sendEmailStatus: -1,
  sendEmailError: -1,

  updateUserDataStatus: -1,
  updateUSerDataError: -1,

  lastRoute : 'welcome',
  lastPath: 'welcome',
  startHour : '',
  endHour : '',
  idSession: '',
  idMarket: '',
  combinacion: '',
  startingMoney: 0,
  language: language || 'es',
  language_status: -1,
  aceptabilidad: null,

  //CAMPAÑA
  idPais: -1,
  abreviatura: "",
  campaign: -1
}

export default function settingsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/modules/module_settings.js